import { WELCOME_TOUR_ID, WELCOME_TOUR_STEPS } from "./welcomeTour";
import { PEOPLE_LEAVE_TOUR_ID, PEOPLE_LEAVE_TOUR_STEPS } from "./peopleLeaveTour";
import {
  PEOPLE_TIMESHEET_TOUR_ID,
  PEOPLE_TIMESHEET_TOUR_STEPS,
} from "./peopleTimesheetTour";
import {
  PEOPLE_MY_DAY_TOUR_ID,
  PEOPLE_MY_DAY_TOUR_STEPS,
} from "./peopleMyDayTour";
import {
  PEOPLE_ATTENDANCE_TOUR_ID,
  PEOPLE_ATTENDANCE_TOUR_STEPS,
} from "./peopleAttendanceTour";
import {
  PEOPLE_APPROVALS_TOUR_ID,
  PEOPLE_APPROVALS_TOUR_STEPS,
} from "./peopleApprovalsTour";
import {
  PEOPLE_TA_NAV_TOUR_ID,
  PEOPLE_TA_NAV_TOUR_STEPS,
} from "./peopleTaNavTour";
import {
  TEAM_CHECKINS_TOUR_ID,
  TEAM_CHECKINS_TOUR_STEPS,
} from "./teamCheckinsTour";

/**
 * Tour registry — add new module tours here.
 * Each entry: { id, name, autoStart?, mandatory?, steps }
 */
export const TOURS = {
  [WELCOME_TOUR_ID]: {
    id: WELCOME_TOUR_ID,
    name: "Product tour",
    autoStart: true,
    steps: WELCOME_TOUR_STEPS,
  },
  [PEOPLE_TA_NAV_TOUR_ID]: {
    id: PEOPLE_TA_NAV_TOUR_ID,
    name: "Time & Attendance navigation",
    autoStart: false,
    steps: PEOPLE_TA_NAV_TOUR_STEPS,
  },
  [PEOPLE_MY_DAY_TOUR_ID]: {
    id: PEOPLE_MY_DAY_TOUR_ID,
    name: "Dashboard quick start",
    autoStart: false,
    steps: PEOPLE_MY_DAY_TOUR_STEPS,
  },
  [PEOPLE_ATTENDANCE_TOUR_ID]: {
    id: PEOPLE_ATTENDANCE_TOUR_ID,
    name: "Daily Attendance quick start",
    autoStart: false,
    steps: PEOPLE_ATTENDANCE_TOUR_STEPS,
  },
  [PEOPLE_LEAVE_TOUR_ID]: {
    id: PEOPLE_LEAVE_TOUR_ID,
    name: "Leave quick start",
    autoStart: false,
    steps: PEOPLE_LEAVE_TOUR_STEPS,
  },
  [PEOPLE_TIMESHEET_TOUR_ID]: {
    id: PEOPLE_TIMESHEET_TOUR_ID,
    name: "Time & Attendance quick start",
    autoStart: false,
    steps: PEOPLE_TIMESHEET_TOUR_STEPS,
  },
  [PEOPLE_APPROVALS_TOUR_ID]: {
    id: PEOPLE_APPROVALS_TOUR_ID,
    name: "Approvals quick start",
    autoStart: false,
    steps: PEOPLE_APPROVALS_TOUR_STEPS,
  },
  [TEAM_CHECKINS_TOUR_ID]: {
    id: TEAM_CHECKINS_TOUR_ID,
    name: "Team Check-Ins quick start",
    autoStart: false,
    mandatory: true,
    steps: TEAM_CHECKINS_TOUR_STEPS,
  },
};

export function getTour(tourId) {
  return TOURS[tourId] || null;
}

export { WELCOME_TOUR_ID, WELCOME_TOUR_STEPS };
export { PEOPLE_TA_NAV_TOUR_ID, PEOPLE_TA_NAV_TOUR_STEPS };
export { PEOPLE_MY_DAY_TOUR_ID, PEOPLE_MY_DAY_TOUR_STEPS };
export { PEOPLE_ATTENDANCE_TOUR_ID, PEOPLE_ATTENDANCE_TOUR_STEPS };
export { PEOPLE_LEAVE_TOUR_ID, PEOPLE_LEAVE_TOUR_STEPS };
export { PEOPLE_TIMESHEET_TOUR_ID, PEOPLE_TIMESHEET_TOUR_STEPS };
export { PEOPLE_APPROVALS_TOUR_ID, PEOPLE_APPROVALS_TOUR_STEPS };
export { TEAM_CHECKINS_TOUR_ID, TEAM_CHECKINS_TOUR_STEPS };
